(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memoryvault-complete-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const withoutEmDashes = value => value.replace(/(\bValue)\s*\u2014\s*/gi, '$1: ').replace(/\s*\u2014\s*/g, ', ');
  const fixMegapixel = value => value.replace(/Mega\s+Pixel(s?)/gi, 'Megapixel$1');
  const cleanPageCopy = root => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: node => node.parentElement?.closest('script,style,textarea,template,svg,.mvp-featured-collection') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    });
    let node;
    while ((node = walker.nextNode())) {
      const cleaned = fixMegapixel(withoutEmDashes(node.nodeValue));
      if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
    }
    root.querySelectorAll('[aria-label],[aria-valuetext],[alt],[title]').forEach(element => {
      if (element.closest('.mvp-featured-collection')) return;
      ['aria-label','aria-valuetext','alt','title'].forEach(attribute => {
        const value = element.getAttribute(attribute);
        if (!value) return;
        const cleaned = fixMegapixel(withoutEmDashes(value));
        if (cleaned !== value) element.setAttribute(attribute, cleaned);
      });
    });
  };
  const states = new WeakMap();
  const init = root => {
    if (states.has(root)) return;
    cleanPageCopy(root);
    const controller = new AbortController();
    const signal = controller.signal;
    root.querySelectorAll('[data-mvp-video]').forEach(media => {
      const button = media.querySelector('[data-mvp-video-play]');
      const video = media.querySelector('video');
      const iframe = media.querySelector('iframe');
      if (!button || (!video && !iframe)) return;
      if (video) {
        const posterMedia = window.matchMedia('(max-width: 767px)');
        const refreshPoster = () => {
          const poster = posterMedia.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
          if (poster) video.poster = poster;
        };
        refreshPoster();
        posterMedia.addEventListener('change', refreshPoster, {signal});
      }
      button.hidden = false;
      button.addEventListener('click', () => {
        button.hidden = true;
        if (video) {
          video.focus({preventScroll: true});
          const playing = video.play();
          if (playing && playing.catch) playing.catch(() => { button.hidden = false; });
        } else {
          const url = new URL(iframe.src);
          url.searchParams.set('autoplay', '1');
          iframe.src = url.toString();
          iframe.focus({preventScroll: true});
        }
      }, {signal});
      if (video) {
        video.addEventListener('play', () => { button.hidden = true; }, {signal});
        video.addEventListener('ended', () => { button.hidden = false; }, {signal});
      }
    });

    root.querySelectorAll('[data-mvp-featured]').forEach(featured => {
      const radios = [...featured.querySelectorAll('.mvp-pack-radio')];
      const buy = featured.querySelector('[data-mvp-buy]');
      const buyName = featured.querySelector('[data-mvp-buy-name]');
      const refreshBundle = () => {
        const selected = radios.find(radio => radio.checked);
        if (!selected || !buy) return;
        buy.href = selected.dataset.bundleUrl;
        buyName.textContent = ': ' + withoutEmDashes(selected.dataset.bundleName);
      };
      featured.addEventListener('change', event => {
        if (event.target.matches('.mvp-pack-radio')) refreshBundle();
      }, {signal});
      featured.addEventListener('click', event => {
        const thumb = event.target.closest('[data-mvp-thumb]');
        if (thumb && featured.contains(thumb)) {
          featured.querySelectorAll('[data-mvp-photo]').forEach(photo => {
            photo.hidden = photo.dataset.mvpPhoto !== thumb.dataset.mvpThumb;
          });
          featured.querySelectorAll('[data-mvp-thumb]').forEach(button => {
            button.setAttribute('aria-pressed', String(button === thumb));
          });
          return;
        }
        const pack = event.target.closest('[data-mvp-pack]');
        if (pack && !event.target.closest('a,input,label')) {
          const radio = pack.querySelector('.mvp-pack-radio');
          radio.checked = true;
          radio.focus({preventScroll: true});
          refreshBundle();
        }
      }, {signal});
      refreshBundle();
      featured.classList.add('mvp-featured-ready');
      featured.querySelector('[data-mvp-purchase]').hidden = false;
      featured.querySelector('[data-mvp-thumbs]').hidden = false;
    });
    root.querySelectorAll('[data-mvp-offer]').forEach(offer => {
      const packRadios = [...offer.querySelectorAll('.mvp-pk-radio')];
      if (!packRadios.length) return;
      const packBuy = offer.querySelector('[data-mvp-offer-buy]');
      const packPrice = offer.querySelector('[data-mvp-offer-price]');
      const packName = offer.querySelector('[data-mvp-offer-name]');
      const refreshPack = () => {
        const selected = packRadios.find(radio => radio.checked);
        packRadios.forEach(radio => radio.closest('.mvp-pk')?.classList.toggle('mvp-pk--on', radio === selected));
        if (!selected || !packBuy) return;
        packBuy.href = selected.dataset.bundleUrl;
        if (packPrice) packPrice.textContent = selected.dataset.bundlePrice;
        if (packName) packName.textContent = ': ' + withoutEmDashes(selected.dataset.bundleName);
      };
      offer.addEventListener('change', event => {
        if (event.target.matches('.mvp-pk-radio')) refreshPack();
      }, {signal});
      refreshPack();
    });
    root.querySelectorAll('[data-mvp-journey]').forEach(journey => {
      const list = journey.querySelector('[data-mvp-jn-list]');
      const nav = journey.querySelector('[data-mvp-jn-nav]');
      if (!list || !nav) return;
      const steps = [...list.querySelectorAll('[data-mvp-jn-step]')];
      const dots = [...nav.querySelectorAll('[data-mvp-jn-dot]')];
      const prev = nav.querySelector('[data-mvp-jn-prev]');
      const next = nav.querySelector('[data-mvp-jn-next]');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0;
      let scrollFrame = 0;
      const offsetOf = index => steps[index].offsetLeft - steps[0].offsetLeft;
      const goTo = index => {
        index = Math.max(0, Math.min(steps.length - 1, index));
        list.scrollTo({left: offsetOf(index), behavior: reduce.matches ? 'auto' : 'smooth'});
      };
      const syncNav = () => {
        scrollFrame = 0;
        let nearest = 0;
        let distance = Infinity;
        steps.forEach((step, index) => {
          const gap = Math.abs(offsetOf(index) - list.scrollLeft);
          if (gap < distance) { distance = gap; nearest = index; }
        });
        current = nearest;
        dots.forEach((dot, index) => {
          if (index === current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (prev) prev.disabled = current === 0;
        if (next) next.disabled = current >= steps.length - 1;
      };
      list.addEventListener('scroll', () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(syncNav); }, {passive: true, signal});
      window.addEventListener('resize', () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(syncNav); }, {passive: true, signal});
      nav.addEventListener('click', event => {
        const dot = event.target.closest('[data-mvp-jn-dot]');
        if (dot) { goTo(Number(dot.dataset.mvpJnDot)); return; }
        if (event.target.closest('[data-mvp-jn-prev]')) goTo(current - 1);
        else if (event.target.closest('[data-mvp-jn-next]')) goTo(current + 1);
      }, {signal});
      syncNav();
    });

    const sticky = root.querySelector('[data-mvp-sticky]');
    const hero = root.querySelector('.mvp-block--hero');
    const offer = root.querySelector('.mvp-offer');
    const media = window.matchMedia('(max-width: 767px)');
    let frame = 0;
    let observer;
    const update = () => {
      frame = 0;
      if (!sticky || !offer) return;
      const rect = root.getBoundingClientRect();
      const heroPassed = hero ? hero.getBoundingClientRect().bottom <= 0 : rect.top < 0;
      const offerRect = offer.getBoundingClientRect();
      const featuredVisible = [...root.querySelectorAll('[data-mvp-featured]')].some(el => { const bounds = el.getBoundingClientRect(); return bounds.top < window.innerHeight && bounds.bottom > 0; });
      const offerVisible = featuredVisible || offerRect.top < window.innerHeight && offerRect.bottom > 0;
      const focused = document.activeElement;
      const focusedInside = focused && root.contains(focused) && !sticky.contains(focused) && focused !== document.body;
      const focusedLow = focusedInside && focused.getBoundingClientRect().bottom > window.innerHeight - 115;
      const show = media.matches && heroPassed && !offerVisible && rect.bottom > 130 && !focusedLow;
      sticky.hidden = !show;
    };
    const requestUpdate = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    if (sticky && offer) {
      root.classList.add('mvp-has-sticky');
      window.addEventListener('scroll', requestUpdate, {passive: true, signal});
      window.addEventListener('resize', requestUpdate, {passive: true, signal});
      root.addEventListener('focusin', requestUpdate, {signal});
      root.addEventListener('focusout', requestUpdate, {signal});
      if ('ResizeObserver' in window) {
        observer = new ResizeObserver(requestUpdate);
        observer.observe(root);
      }
      update();
    }
    root.addEventListener('click', event => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor || !root.contains(anchor)) return;
      const id = anchor.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (!target || !root.contains(target) && target !== root) return;
      event.preventDefault();
      target.scrollIntoView({behavior: 'instant', block: 'start'});
      target.setAttribute('tabindex', '-1');
      target.focus({preventScroll: true});
      requestUpdate();
    }, {signal});
    states.set(root, () => {
      controller.abort();
      root.querySelectorAll('[data-mvp-video] video').forEach(video => video.pause());
      root.querySelectorAll('[data-mvp-video] iframe').forEach(iframe => iframe.removeAttribute('src'));
      if (observer) observer.disconnect();
      if (frame) cancelAnimationFrame(frame);
      states.delete(root);
    });
  };
  const scan = container => {
    if (container.matches && container.matches('[data-mvp-page]')) init(container);
    container.querySelectorAll('[data-mvp-page]').forEach(init);
  };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-mvp-page]').forEach(root => states.get(root)?.());
  });
})();


  } catch(e) { console.error(e); }
})();
})();
